import PropTypes from 'prop-types'

import AcceptedClientRow from './AcceptedClientRow'
import NoRecords from './NoRecords'


const hasHouseholdData = client => (
  client.record_type === 'household' ||
  Boolean(client.second_first_name || client.second_last_name || client.second_email)
)

const AcceptedClients = props => {
  if (props.accepted.length > 0) {
    const showHouseholdColumns = props.accepted.some(hasHouseholdData)

    return (
      <fieldset className='add-records accepted-records'>
        <p>The following {props.accepted.length} entries are ready to be added. If the list does not look right, make the necessary changes to your .CSV file and <a onClick={props.goBack}>start over</a>.</p>
        {/* Focusable so keyboard users can scroll the table with the arrow keys when it is wider than the modal. */}
        <div
          aria-label='Client entries ready to be added'
          className='confirm-add-many-wrapper'
          role='region'
          tabIndex={0}
        >
          <table className={`confirm-add-many${showHouseholdColumns ? ' household-columns' : ''}`}>
            <thead>
              <tr>
                {showHouseholdColumns && <th>Type</th>}
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                {showHouseholdColumns && <th>First Name 2</th>}
                {showHouseholdColumns && <th>Last Name 2</th>}
                {showHouseholdColumns && <th>Email 2</th>}
              </tr>
            </thead>
            <tbody>
              {props.accepted.map(client => (
                <AcceptedClientRow
                  {...client}
                  key={client.email}
                  showHouseholdColumns={showHouseholdColumns}
                />
              ))}
            </tbody>
          </table>
        </div>
      </fieldset>
    )
  }

  return <NoRecords goBack={props.goBack} />
}

AcceptedClients.propTypes = {
  accepted: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      record_type: PropTypes.string,
      second_email: PropTypes.string,
      second_first_name: PropTypes.string,
      second_last_name: PropTypes.string
    })
  ).isRequired,
  goBack: PropTypes.func.isRequired
}

export default AcceptedClients
